<template lang="pug">
.container
  .banner-out
    img.banner(:src="url ? url : '@/assets/imgs/banner.png'")
    VipOpen(ref="vipOpenRef" @goBuy="goBuy")
  //- buyVip(@closeVip='closeVip' v-if='showBuyVip')
  vipRights
  .vip-list-container(v-if='showMore')
    .content
      morePackage(@closeMorePackage='showMore = false')
  DictWebsiteFooter(theme="gray")
  VipCenter(:debug="AppMode" :isShow="isShowVipCenter" @buyVipSuccess="buyVipSuccess" @closeVipCenter="isShowVipCenter = false" :routeQuery="$route.query")
</template>

<script>
import util from '@/util/index';
// import buyVip from '@/components/buyVip.vue';
import vipRights from '@/components/vipRights.vue';
import VipOpen from '@/components/vipOpen.vue';
import morePackage from '@/components/morePackage.vue';
import service from '@/service/vip';

export default {
  name: 'Home',
  components: {
    // buyVip,
    vipRights,
    VipOpen,
    morePackage,
  },
  data() {
    return {
      showBuyVip: false,
      showMore: false,
      url: '', // 头图链接,
      isShowVipCenter: false,
      AppMode: process.env.VUE_APP_MODE !== 'prod',
    };
  },
  mounted() {
    this.getBanner();
    const keyfrom = util.getQueryVariable('keyfrom') || util.getQueryVariable('source');
    window._rlog.push([
      '_trackCustom',
      'event',
      [
        keyfrom ? ['keyfrom', keyfrom] : '',
        ['type', util.getPlatform()],
        ['show', 'new_cidian_vippage'],
      ],
    ]);
  },
  watch: {
    showBuyVip: {
      handler(val) {
        if (val) {
          this.stopMove();
        } else {
          this.Move();
        }
      },
    },
    showMore: {
      handler(val) {
        if (val) {
          this.stopMove();
        } else {
          this.Move();
        }
      },
    },
    '$route.query.buyVip': {
      handler(val) {
        if (val === 'true') {
          this.goBuy();
        }
      },
      immediate: true,
    },
    '$route.query.buyMore': {
      handler(val) {
        if (val === 'true') {
          this.showMore = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    buyVipSuccess() {
      this.$refs.vipOpenRef.getAccountInfo();
    },
    getBanner() {
      service.getHomeBanner().then((res) => {
        this.url = res.data.value.bannerHeaderMapPicture;
      });
    },
    goBuy() {
      // this.showBuyVip = true;
      this.isShowVipCenter = true;
    },
    closeVip() {
      this.showBuyVip = false;
    },
    // 阻止页面滚动，针对非chrome浏览器
    stopMove() {
      const m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    Move() {
      const m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; // 出现滚动条
      document.removeEventListener('touchmove', m, { passive: true });
    },
  },
};
</script>

<style lang="stylus" scoped>
.container
  min-width 1320px
  .banner-out
    width 100%
    position relative
    // margin-top 70px
    .banner
      width 100%
  .vip-list-container
    position fixed
    top 0
    right 0
    width 100%
    height 100%
    background rgba(9, 11, 15, 0.2)
    display flex
    justify-content center
    align-items center
    z-index 999
    .content
      width 700px
      height 492px
      border-radius 10px
      position relative
      .close
        position absolute
        right 25px
        top 7px
        width 20px
        cursor pointer
</style>
